@if (viewModel) { @if (viewModel.link) {
<a
  ecmPushTracker
  [pdb-zid]="viewModel.zid"
  [pdb-sc]="'adv'"
  [pdb-idc]="viewModel.code"
  [pdb-ta]="viewModel.advTracker"
  [pdb-vi]="viewModel.pictoImage"
  [ecmDisabledAction]="linkDisable || isDisabledEclairLink"
  [href]="viewModel.link | link:getLinkParam() | async"
  (click)="openLink();false"
  class="items-list-item"
  data-e2e="sub-item-link"
>
  <ng-container *ngTemplateOutlet="item"></ng-container>
</a>
} @else {
<div class="items-list-item" data-e2e="sub-item">
  <ng-container *ngTemplateOutlet="item"></ng-container>
</div>
} }

<ng-template #item>
  <img alt="" class="item-icon" src="{{viewModel.pictoImage}}" data-e2e="sub-item-reco" />

  <div [ngClass]="{'border-bottom-0': hideBorder}" class="item-container">
    <div class="item-text">
      <span data-e2e="sub-item-label" [ngClass]="{'text-smagenta1 font-weight-bold': viewModel.textPrimary }" class=""
        >{{viewModel.label}}</span
      >
      <small class="item-desc" data-e2e="sub-item-detail">
        @for (detail of viewModel.detail; track detail) {
        <div>{{detail}}</div>
        }
      </small>
    </div>
    @if (viewModel.alert) {
    <i
      data-e2e="sub-item-alert"
      class="item-status icon-info icon-Warning-important text-warning"
      aria-hidden="true"
    ></i>
    }
  </div>
</ng-template>
